// @ts-nocheck
import * as Types from "../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type CheckConfigListQueryVariables = Types.Exact<{
  organizationSlug: Types.Scalars["ID"]["input"];
  checkGroupAndName: Types.Scalars["String"]["input"];
}>;

export type CheckConfigListQuery = {
  __typename?: "GraphqlQuery";
  getCheckConfigs: Array<{
    __typename?: "CheckConfig";
    id: string;
    enabled: boolean;
    settings: any;
    server: {
      __typename?: "Server";
      id: string;
      humanId: string;
      name: string;
    };
  }>;
};

export const CheckConfigListDocument = gql`
  query CheckConfigList($organizationSlug: ID!, $checkGroupAndName: String!) {
    getCheckConfigs(
      organizationSlug: $organizationSlug
      checkGroupAndName: $checkGroupAndName
    ) {
      id
      server {
        id
        humanId
        name
      }
      enabled
      settings
    }
  }
`;

/**
 * __useCheckConfigListQuery__
 *
 * To run a query within a React component, call `useCheckConfigListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckConfigListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckConfigListQuery({
 *   variables: {
 *      organizationSlug: // value for 'organizationSlug'
 *      checkGroupAndName: // value for 'checkGroupAndName'
 *   },
 * });
 */
export function useCheckConfigListQuery(
  baseOptions: Apollo.QueryHookOptions<
    CheckConfigListQuery,
    CheckConfigListQueryVariables
  > &
    (
      | { variables: CheckConfigListQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CheckConfigListQuery, CheckConfigListQueryVariables>(
    CheckConfigListDocument,
    options,
  );
}
export function useCheckConfigListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CheckConfigListQuery,
    CheckConfigListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CheckConfigListQuery,
    CheckConfigListQueryVariables
  >(CheckConfigListDocument, options);
}
// @ts-ignore
export function useCheckConfigListSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CheckConfigListQuery,
    CheckConfigListQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  CheckConfigListQuery,
  CheckConfigListQueryVariables
>;
export function useCheckConfigListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CheckConfigListQuery,
        CheckConfigListQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  CheckConfigListQuery | undefined,
  CheckConfigListQueryVariables
>;
export function useCheckConfigListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CheckConfigListQuery,
        CheckConfigListQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CheckConfigListQuery,
    CheckConfigListQueryVariables
  >(CheckConfigListDocument, options);
}
export type CheckConfigListQueryHookResult = ReturnType<
  typeof useCheckConfigListQuery
>;
export type CheckConfigListLazyQueryHookResult = ReturnType<
  typeof useCheckConfigListLazyQuery
>;
export type CheckConfigListSuspenseQueryHookResult = ReturnType<
  typeof useCheckConfigListSuspenseQuery
>;
export type CheckConfigListQueryResult = Apollo.QueryResult<
  CheckConfigListQuery,
  CheckConfigListQueryVariables
>;
